var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocallyGrown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7801_40917)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.652161,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#22AC38"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.65216 0C13.0704 0 16.6522 3.58172 16.6522 8C16.6522 12.4183 13.0704 16 8.65216 16C4.23388 16 0.652161 12.4183 0.652161 8C0.652161 3.58172 4.23388 0 8.65216 0ZM8.65222 13.4688C11.3816 10.5248 12.5997 8.34819 12.5915 6.44387C12.5814 4.04709 10.6348 2.57272 8.75872 2.53231C8.73072 2.5315 8.70254 2.53125 8.67454 2.53125C7.64304 2.53125 6.62904 2.94016 5.88038 3.66084C5.36032 4.16128 4.73569 5.04106 4.71335 6.38953C4.69769 7.33709 4.99207 8.34744 5.61335 9.47822C6.25788 10.6514 7.25385 11.9597 8.65222 13.4688ZM8.65216 3.707C7.20344 3.707 6.02475 4.88566 6.02475 6.33441C6.02475 7.78319 7.20344 8.96184 8.65216 8.96184C10.1009 8.96184 11.2796 7.78319 11.2796 6.33441C11.2796 4.88569 10.1009 3.707 8.65216 3.707ZM8.65216 8.16747C9.66294 8.16747 10.4852 7.34528 10.4852 6.33441C10.4852 5.32381 9.66294 4.50138 8.65216 4.50138C7.64141 4.50138 6.81913 5.32381 6.81913 6.33441C6.81916 7.34528 7.64144 8.16747 8.65216 8.16747Z",
    fill: "#C7EACD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7801_40917"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.652161,
    width: 16,
    height: 16,
    rx: 8,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocallyGrown);
export default __webpack_public_path__ + "static/media/locally-grown.34f8a9d9.svg";
export { ForwardRef as ReactComponent };